if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function (e) {
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          if (s.classList.contains("filter-by")) {
            var event = new Event("change");
            s.dispatchEvent(event);
          }
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);
(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.acc-btn').click(function(e){
        e.preventDefault();
       if($(this).hasClass('active')){
        $(this).removeClass("active");
        $(this).next().slideToggle();
       }else{
        $(".acc-btn").removeClass("active");
        $(".tab-content").slideUp();
        $(this).addClass('active');
        $(this).next().slideToggle();
       }
    });
    $(".filter-by").on("change", function () {
        var filterArea = $(this).attr('data-filter-section');
        var filterby = $(this).val();
        if (filterby == "") {
            $(".filter-block").show();
            $(".filter-block .animate-fade").addClass('fade-in visible');
        }else{
            var selectedBlocks = $("#" + filterArea).children(".filter-block[data-filter*='" + filterby+"']");
            $("#" + filterArea).children(".filter-block[data-filter*='" + filterby+"']").remove();
            $('.filter-block').hide();
            $(selectedBlocks).prependTo("#" + filterArea);
            $("#" + filterArea).children(".filter-block[data-filter*='" + filterby+"']").show();
            $("#" + filterArea).children(".filter-block[data-filter*='" + filterby+"']").find('.animate-fade').addClass("fade-in visible");
        }
        $(".filter-block .sym-slides").slick("unslick");
        $(".filter-block .sym-slides").slick({
          accessibility: true,
        });
    });
    $("video").on("ended", function () {
      //TO DO: Your code goes here...
      this.load();
    });

    setTimeout(function(){
			$('.pin-website').addClass("btn");
		},1000);

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
  const menu = document.querySelector('#menu');
  const isMenuVisible = menu && menu.classList.contains('opened');
  const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
  
  elements.forEach(element => {
      element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateMenuTabIndex();

  document.addEventListener('focusin', updateMenuTabIndex);
  const menu = document.querySelector('#menu');
  if (menu) {
      menu.addEventListener('transitionend', updateMenuTabIndex);
  }
});


/** Accessibility Adjustment for All Slides **/

$(document).ready(function() {
  $('.sym-slides').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

    var slides = $(slick.$slides);

    slides.each(function() {
        var slide = $(this);
        if (slide.attr('aria-hidden') === 'true') {
            slide.attr('tabindex', '-1');
        } else {
            slide.attr('tabindex', '0');
        }
    });

    $(slick.$slides.eq(nextSlide)).attr('tabindex', '0');
  });
});

/** Hide specific footer navigation elements for Hilton Garden Inn Site (ID: 1944) **/

document.addEventListener('DOMContentLoaded', function(){
  const footerNav = document.querySelector('.site-1944 .footer .sub-menu ul');

  if(footerNav){
    const itemsToHide = ['sn-4', 'sn-5', 'sn-6'];
    const navItems = footerNav.querySelectorAll('li');

    navItems.forEach(li => {
      if (itemsToHide.some(cls => li.classList.contains(cls))) {
        li.classList.add('hidden');
      }
    });    
  }
});